import Vue from 'vue'

import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
// import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory'
import { createUploadLink } from 'apollo-upload-client'

import errorLink from './error'
// import { GC_AUTH_TOKEN } from './constants'

// function getAuth() {
//   // get the authentication token from local storage if it exists
//   const token = sessionStorage.getItem(GC_AUTH_TOKEN) || localStorage.getItem(GC_AUTH_TOKEN)
//   // return the headers to the context so httpLink can read them
//   return token ? `Bearer ${token}` : ''
// }

// let link = new HttpLink({
//   // You should use an absolute URL here
//   uri: 'http://localhost:4000/',
//   credentials: 'same-origin',
// });

// http://10.232.5.168:8080/#/stores
const [http, afterHttp] = window.location.toString().split('://')
const [url] = afterHttp.split('/')
let [baseUrl] = url.split(':')
let graphqlPath = process.env.GRAPHQL_PATH
if (process.env.NODE_ENV === 'development') {
  const localNetwork = ['192.168.100.49', 'localhost']
  if (!localNetwork.includes(baseUrl)) {
    baseUrl = 'clerkretail-graphql.watacorp.com'
    graphqlPath = '/graphql'
  }
}
const uploadLink = createUploadLink({
  // You should use an absolute URL here
  uri: `${http}://${process.env.NODE_ENV === 'development' ? '' : 'api.'}${baseUrl}${graphqlPath}/`,
  credentials: 'include',
})

const locationMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      'X-Requesting-Page': window.location.hash.toString(),
    },
  })

  return forward(operation)
})

const cache = new InMemoryCache({
  dataIdFromObject: (object) => {
    // eslint-disable-next-line no-underscore-dangle
    switch (object.__typename) {
      case 'Name': {
        if (!object.name) {
          // TODO dk what any of this does, just trying to fix a bug
          return defaultDataIdFromObject(object)
        }
        return `${object.id}:${object.name.split(' ').join('')}`
      } default: {
        return defaultDataIdFromObject(object) // fall back to default handling
      }
    }
  },
})

// Install the vue plugin
Vue.use(VueApollo)

// Create the apollo client
const apolloClient = new ApolloClient({
  link: ApolloLink.from([locationMiddleware, errorLink, uploadLink]),
  cache,
  connectToDevTools: true,
})

// Create vue apollo provider
export default new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $loadingKey: 'loading',
    httpLinkOptions: {
      uri: `${http}://${process.env.NODE_ENV === 'development' ? '' : 'api.'}${baseUrl}${process.env.GRAPHQL_PATH}/`,
      credentials: 'include',
    },
  },
})



// WEBPACK FOOTER //
// ./src/graphql/index.js